import { FC, useState } from "react";
import { MEDIA_VALUES } from "./constants";
import MediaItem from "./MediaItem";
import { Button } from "../UI/Buttons/Button";

const MediaList: FC = () => {
  const [visibleMediaCardsCount, setVisibleMediaCardsCount] = useState(3);
  const handleLoadMore = () => {
    setVisibleMediaCardsCount((prevCount) => prevCount + 3);
  };

  return (
    <>
      <section className="grid w-full grid-cols-1 gap-6 md:grid-cols-3">
        {MEDIA_VALUES.slice(0, visibleMediaCardsCount).map(
          ({ id, link, label, img_src, main_img, date }) => (
            <MediaItem
              key={id}
              link={link}
              label={label}
              img_src={img_src}
              main_img={main_img}
              date={date}
            />
          ),
        )}
      </section>

      {visibleMediaCardsCount < MEDIA_VALUES.length && (
        <div className="mt-8 flex w-full justify-center">
          <Button onClick={handleLoadMore} className="">
            Žiūrėti daugiau
          </Button>
        </div>
      )}
    </>
  );
};

export default MediaList;
